"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[48513],{

/***/ 48513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Lawsuit; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Lawsuit() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "relative my-10",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "py-10 md:p-16 flex justify-center items-center flex-col",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        color: "#272361"
                    },
                    className: "text-center font-semibold text-xl md:text-3xl md:w-3/4",
                    children: "What Is the Camp Lejeune Lawsuit?"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        color: "#444b53"
                    },
                    className: "mt-6 text-justify md:text-lg w-7/8 md:text-center font-light",
                    children: "The Camp Lejeune lawsuit aims to give money to people who lived or worked at the Marine Corps base in North Carolina between 1953 and 1987 and were exposed to toxic water. The contamination affected over a million people and resulted in illnesses such as cancer and birth defects. The lawsuit wants to hold the government accountable for not doing enough and compensate those who have been hurt."
                })
            ]
        })
    });
}


/***/ })

}]);